import React, { Component } from 'react'

import style from './style.module.css'

export default class Button extends Component {
    render() {
        const { children, className, loading, primary, disabled, light, mid, lightOutline, spacing, secondary, secondaryOutline, transparent, inline, small, ...props } = this.props

        const classes = [style.btn]

        if(primary)
        classes.push(style.primary)

        if(light)
        classes.push(style.light)

        if(lightOutline)
        classes.push(style.lightOutline)

        if(transparent)
        classes.push(style.transparent)

        if(mid)
        classes.push(style.mid)

        if(secondary)
        classes.push(style.secondary)
        
        if(secondaryOutline)
        classes.push(style.secondaryOutline)

        if(inline)
        classes.push(style.inline)

        if(small)
        classes.push(style.small)

        if(className)
        classes.push(className)

        if(spacing)
        classes.push(style[`spacing-${spacing}`])


        return (
            <button className={classes.join(' ')} { ...props } disable={loading || disabled ? 'true' : 'false'}>
                {loading && <div className={style.loader} />}
                <span>{children}</span>
            </button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Button/index.js